import styled from 'styled-components'

export const CustomLabel = styled.label`
  color: var(--dark-gray);
  font-size: 16px;
  font-weight: 600;
`

export const CustomTitleCadastro = styled.h3`
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin-top: 30px;
`
export const CardInfoPurple = styled.div`
  background: #662d9133;
  border: solid 1px var(--roxo-riber);
  border-radius: 15px;
  color: var(--roxo-riber);
  font-weight: 500;
  padding: 18px;
`

export const CustomLink = styled.label`
  color: var(--dark-gray);
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  text-decoration: underline;
`
export const Subtitle = styled.p`
  font-size: 14px;
  color: #555;
  text-align: center;
  margin-top: -10px;
`

export const InfoBox = styled.div`
  display: flex;
  align-items: center;
  border: 1.5px solid #87b5f5ff;
  border-radius: 8px;
  padding: 10px 12px;
  margin-top: 16px;
  cursor: pointer;
  color: #1a57c2;
  font-size: 16px;
  gap: 8px;

  &:hover {
    background-color: #dbe9ff;
  }
`

export const InfoLink = styled.span`
  font-weight: 500;
`
